import { addReducer } from "../../types/IExtensionContext";
import { getSafe, setSafe, } from "../../util/storeHelper";
import * as actions from "./actions";
const persistentReducer = {
    reducers: {
        ...addReducer(actions.addHistoryEvent, (state, payload) => {
            const path = ["historyStacks", payload.stack];
            const copy = getSafe(state, path, []).slice(payload.limit * -1 - 1);
            copy.push(payload.event);
            return setSafe(state, path, copy);
        }),
        ...addReducer(actions.setHistoryEvent, (state, payload) => {
            const idx = state.historyStacks[payload.stack].findIndex((evt) => evt.id === payload.event.id);
            const copy = setSafe(state, ["historyStacks", payload.stack, idx], payload.event);
            return copy;
        }),
        ...addReducer(actions.markHistoryReverted, (state, payload) => {
            const idx = state.historyStacks[payload.stack].findIndex((evt) => evt.id === payload.event.id);
            const copy = setSafe(state, ["historyStacks", payload.stack, idx, "reverted"], true);
            return copy;
        }),
    },
    defaults: {
        historyStacks: {},
    },
};
const sessionReducer = {
    reducers: {
        ...addReducer(actions.showHistory, (state, payload) => setSafe(state, ["stackToShow"], payload)),
    },
    defaults: {
        stackToShow: undefined,
    },
};
export { persistentReducer, sessionReducer };
